import { Observable } from 'rxjs';
import { CollectsAnalyticsQuery, CollectsSnapshotResponse, CollectsDistributionResponse, CollectsTrendsResponse, CollectsGeoResponse } from './collects-analytics.model';

export abstract class CollectsAnalyticsService {
    abstract getSnapshot(query: CollectsAnalyticsQuery): Observable<CollectsSnapshotResponse>;
    abstract getDistribution(query: CollectsAnalyticsQuery): Observable<CollectsDistributionResponse>;
    abstract getTrends(query: CollectsAnalyticsQuery): Observable<CollectsTrendsResponse>;
    abstract getGeo(query: CollectsAnalyticsQuery): Observable<CollectsGeoResponse>;
}
